import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ElementRef } from '@angular/core';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { HostListener } from '@angular/core';
import { Settings } from '../../../services/settings';

import { DatePipe } from '@angular/common';
import { UserEntity } from 'src/app/models/user-entity';
import { DwUtils } from "../../../components/utils/dw-utils";
import { SecurityService } from 'src/app/services/security.service';
import { SecurityTargetElement } from 'src/app/models/security-target-element';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { TransactionHistoryComponent } from 'src/app/components/transaction-history/transaction-history';
import { ValidationResult } from 'src/app/models/validation-result';


@Component({
	selector: 'app-security-target-definitions',
	templateUrl: './security-target-definitions.component.html',
	styleUrls: ['./security-target-definitions.component.css']
})
export class SecurityTargetDefinitionsComponent implements OnInit {

	formTitle = 'Security Elements';
	displayedColumns: string[] = ['id', 'name', 'primaryPath', 'description', 'elementType', 'options', 'activeStatus'];
	public selectedRecord: SecurityTargetElement;
	public historyRecord: SecurityTargetElement;
	public records = Array<SecurityTargetElement>();
	public dataSource: MatTableDataSource<SecurityTargetElement>;
	public pagination: string;
	Idx = -1;
	visibleAdd = false;
	visibleModify = false;
	visibleDelete = false;
	isEditing = false;
	busyCursor = false;

	public selectedStatusFilter: string | null = 'Active';

	// data related
	id = 0;
	name: string = '';
	code: string = '';
	primaryPath: string = '';
	usedInMultipleAreas: boolean = false;
	description: string = '';
	elementType: string = 'Component';
	active: string = 'Active';
	read: boolean = false;
	write: boolean = false;
	execute: boolean = false;
	show: boolean = false;
	activeStatus = 'Active';

	strErr: string = '';
	selectedTabIndex = 0;

	disabledFlag = true;
	elementTypeList: any;

	usableOptionsList: string[] = ['Read', 'Write', 'Execute', 'Show'];
	usableOptions: string[] = []; // holds selected items

	public contentClassWithBanner = 'dwtable-container';
	public contentClassWithoutBanner = 'dwtable-container-without-header';
	public contentClassName = 'dwtable-container';

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	constructor(private securityService: SecurityService, public dialog: MatDialog, private txService: TransactionHistoryService) {

	}

	ngOnInit(): void {
		if (Settings.getInstance().hasPrivilege("SECURITY_TARGETS", "WRITE")) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleDelete = true;
		}
		this.elementTypeList = [];

		const values = ['Component', 'Field', 'Control', 'Option', 'Navigation'];
		for (const val of values) {
			this.elementTypeList.push({ id: val, description: val });
		}
		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
		this.queryRecords();
	}

	private queryRecords() {

		this.securityService.getAllSecurityTargetElements().subscribe(
			(data) => {
				this.records = data.map((rec: SecurityTargetElement) => {
					const opts: string[] = [];
					if (rec.optionReadOnly) opts.push('read');
					if (rec.optionReadWrite) opts.push('write');
					if (rec.optionExecute) opts.push('execute');
					if (rec.optionShow) opts.push('show');
					rec.options = opts.join(', ');
					return rec;
				});
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.setPagination(-1, this.dataSource.filteredData.length);
				this.onChangeStatusFilterValue();
			},
			(error) => {
				Settings.getInstance().handleError(error, "Fetching all function groups");
			}
		);
	}

	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}


	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}


		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}

	public applyFilter(filterValue: string) {
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public displayDetail(record: SecurityTargetElement) {
		if (!record) {
			return;
		}

		this.id = record.id;
		this.name = record.name;
		this.code = record.code;
		this.primaryPath = record.primaryPath;
		this.usedInMultipleAreas = record.usedInMultipleAreas;
		this.description = record.description;
		this.elementType = record.elementType;
		this.activeStatus = record.activeStatus;
		this.read = record.optionReadOnly;
		this.write = record.optionReadWrite;
		this.execute = record.optionExecute;
		this.show = record.optionShow;
		this.usableOptions = [];
		if (record.optionReadOnly) this.usableOptions.push('Read');
		if (record.optionReadWrite) this.usableOptions.push('Write');
		if (record.optionExecute) this.usableOptions.push('Execute');
		if (record.optionShow) this.usableOptions.push('Show');
		//this.history.onShowHandler('SecurityTargetElement', 'id', record.id.toString());
	}

	public addModifyRecord(isAdd: boolean) {
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (!isAdd) {
			this.historyRecord = this.selectedRecord;
		} else {
			return;

		}
		DwUtils.setFocus('description');
	}

	public onRowClicked(selected: any) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}

	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.displayDetail(this.selectedRecord);
	}

	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) return;

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < len - 1) {
				this.Idx++;
				this.selectedRecord = this.dataSource.filteredData[this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.Idx--;
				this.selectedRecord = this.dataSource.filteredData[this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public validateFields(editingRec: SecurityTargetElement): boolean {

		this.strErr = '';
		const vr: ValidationResult = editingRec.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}

	public submitRecord() {
		let editingRec = new SecurityTargetElement();
		editingRec.id = this.id;
		editingRec.description = DwUtils.capitalize(this.description);
		editingRec.activeStatus = this.activeStatus;

		this.strErr = '';

		if (!this.validateFields(editingRec)) {
			return;
		}

		this.securityService.updateSecurityTargetElement(editingRec).subscribe(
			() => {
				this.isEditing = false;
				this.selectedRecord.activeStatus = editingRec.activeStatus;
				this.selectedRecord.description = editingRec.description;
				this.updateSelectedRow();
			},
			() => {
				this.strErr = 'Error: The server could not update this record';
				this.selectedRecord = this.historyRecord;
				return;
			}
		);

		this.txService.updateTransactionHistory(
			this.historyRecord,
			this.selectedRecord,
			'SecurityTargetElements',
			this.selectedRecord.id
		);
	}

	public onChangeStatusFilterValue() {
		const dataTemp: SecurityTargetElement[] = [];
		//this.clearFilter();
		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}

	public updateSelectedRow(): void {

		const index: number = this.records.findIndex(r => r.id === this.selectedRecord.id);

		if (index >= 0) {
			this.records[index] = this.selectedRecord;
		}
	}

	public selectRow() {
		if (!this.selectedRecord || !this.selectedRecord.id) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}

	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new SecurityTargetElement();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}

	public onStatusChange() {

		this.securityService.updateSecurityTargetElement(this.selectedRecord).subscribe(
			() => {
				// no user feedback, just apply the filter ...
				this.updateSelectedRow();
			});
	}


}
